// Vendors
import $ from 'jquery';

// Sub nav updates
const $subNavHome = $('.sub-nav--home');
const $subNavCustomMenu = $('.sub-nav--custom-menu');

if ($subNavHome.length && $subNavCustomMenu.length) {
  // modify markup
  $subNavHome
    .siblings('.sub-nav--item')
    .wrapAll("<div class='sub-nav--menu'></div>");
  $subNavHome.parent().wrapAll("<div class='sub-nav--item-container'></div>");

  $subNavHome.on('click', (event) => {
    const $currentTarget = event.target;

    // only slideToggle when div clicked
    if ($currentTarget.classList.contains('sub-nav--home')) {
      event.preventDefault();
      $('.sub-nav--menu').slideToggle();
    }
  });

  // disable Committee Materials click
  $('.sub-nav--item a').on('click', (event) => {
    if (event.currentTarget.innerHTML.includes('Committee Materials')) {
      event.preventDefault();
    }
  });
}
